if (!customElements.get('style-guide')) {
    class StyleGuide extends HTMLElement {
        constructor() {
            super();
            this.setEventListeners();
            this.startGuide();
        }

        async startGuide() {
            this.intro = this.querySelector(".question-and-answer-wrap[data-step='0']");
            this.totalSteps = this.getAttribute('data-total-steps');
            this.questionIndex = 0;
            this.targetCollection = this.getAttribute('data-target-collection');
            this.redirectDelay = this.getAttribute('data-redirect-delay');
            this.typeDelay = this.getAttribute('data-type-delay');
            document.querySelector('body').style.overflow = 'hidden'; // remove scroll on body

            this.intro.classList.add('ready');
            await this.showText(this.intro); // Wait for intro text to finish
            this.startStep(1); // Then start step 1
        }

        setEventListeners() {
            this.querySelectorAll('.answer').forEach(answer => {
                answer.addEventListener('click', this.selectOption.bind(this));
            });
            this.querySelector('.close-icon').addEventListener('click', this.returnToPreviousPage)
        }

        selectOption(event) {
            const selectedOption = event.target.closest('.answer');
            const optionQuestion = event.target.closest('.question-and-answer-wrap');
            const optionQuestionIndex = optionQuestion.getAttribute('data-step');

            // deselect all other option in this question
            optionQuestion.querySelectorAll(".answer").forEach(option => { option.classList.remove('selected') });

            // select the clicked option
            selectedOption.classList.add('selected');

            // start the next step if the option that is changed is part of the last question that has been opened
            if (parseInt(optionQuestionIndex) == this.questionIndex) {
                const newProgress = (this.questionIndex * (90 / this.totalSteps) + 10) + '%';
                this.style.setProperty('--progress', newProgress)
                if (this.questionIndex == this.totalSteps) {
                    this.completeGuide();
                } else {
                    this.startStep(this.questionIndex + 1);
                }
            }
        }

        async startStep(index) {
            this.questionIndex = index;
            const questionWrap = this.querySelector(".question-and-answer-wrap[data-step='" + index + "']");
            const answersWrap = questionWrap.querySelector('.answers-wrap');
            const scrollWrap = document.querySelector('.style-guide__questions-wrapper');
            questionWrap.classList.add('ready');
            scrollWrap.scrollIntoView({ behavior: 'smooth', block: 'end' });
            await this.showText(questionWrap); // Wait for each text in step 1 to show one by one
            scrollWrap.scrollIntoView({ behavior: 'smooth', block: 'end' });
            answersWrap.classList.add('ready'); // then show the answer options
            scrollWrap.scrollIntoView({ behavior: 'smooth', block: 'end' });
            window.scrollBy(0, 48); // Scroll 3rem (48px) further after block end
        }

        async showText(elem) {
            elem.textStrings = elem.querySelectorAll("[data-text]");

            // Loop through each text string and await its animation one by one
            for (const textString of elem.textStrings) {
                await this.animateText(textString); // Wait for the current text to finish before moving to the next
            }
        }

        // Animate text and return a Promise that resolves when animation completes
        animateText(textString) {
            return new Promise(resolve => {
                const text = textString.getAttribute('data-text');
                let index = 0;

                function animateText() {
                    textString.textContent = text.slice(0, index);
                    index++;
                    if (index > text.length) {
                        clearInterval(intervalId); // Stop when the text is fully displayed
                        resolve(); // Resolve when the text animation is complete
                    }
                }

                const intervalId = setInterval(animateText, this.typeDelay);
            });
        }

        completeGuide() {
            // show guide complete message and loading animation
            this.querySelector('.quiz-complete-wrap').classList.add('ready');
            document.querySelector('.style-guide__questions-wrapper').scrollIntoView({ behavior: 'smooth', block: 'end' });

            this.querySelectorAll('.animated_dot').forEach(dot => { dot.style.animationPlayState = 'running' });

            // create filterURL and redirect after the chosen "loading" delay
            setTimeout(() => {
                const urlString = this.createFilterURL();
                window.location.href = urlString;
            }, this.redirectDelay);
        }

        createFilterURL() {
            let urlString = '/collections/' + this.targetCollection + '?sort_by=title-ascending';
            let index = 0;
            this.querySelectorAll('.question-and-answer-wrap').forEach(question => {
                if (question.querySelector('.answer.selected')) {
                    index++;
                    const filterHandle = question.getAttribute("data-filter-handle");
                    const selectedOptionHandles = question.querySelector('.answer.selected').getAttribute("data-option-handle").split(',');
                    selectedOptionHandles.forEach(handle => {
                        const questionString = '&' + filterHandle + '=' + handle;
                        urlString = urlString + questionString;
                    })
                }
            })
            return urlString;
        }

        returnToPreviousPage() {
            window.history.back();
        }
    }

    customElements.define('style-guide', StyleGuide);
}
